module.exports = __webpack_public_path__ + "static/img/mobilesquare-04.fd030ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilesquare-04.png
// module id = /7zP
// module chunks = 1